<template>
  <section>
    <slot name="label">
      <h2 class="mb-0">Tag {{ $t('Color') }}/{{ $t('style') }}</h2>
    </slot>
    <b-row class="px-2">
      <b-col v-for="option in options" :key="option.name" cols="3" class="p-2">
        <b-button
          v-if="
            option.smallInStock ||
            option.largeInStock ||
            option.XSInStock ||
            option.SInStock ||
            option.MInStock ||
            option.LInStock ||
            option.XLInStock
          "
          :ref="option.name"
          v-testid="{ id: 'tag-color-option', key: option.name }"
          class="color-option text-center p-1"
          :class="{ selected: option.name == color }"
          :title="option.name"
          :aria-label="`Choose ${option.name}`"
          @click="setColor(option.name)"
          @focus="setFocus(option.name)"
          @focusout="unsetFocus"
        >
          <img
            v-if="option.image"
            v-lazy="getImage(option.image.original)"
            v-testid="{ id: 'tag-color-option-image', key: option.name }"
            alt=""
            width="100%"
          />
        </b-button>
        <div v-else title="Out of Stock" class="text-center p-1">
          <div class="no-stock">
            <img v-if="option.image" v-lazy="getImage(option.image.original)" alt="" width="100%" />
            <svg aria-hidden="true"><line x1="0" y1="100%" x2="100%" y2="0" /></svg>
          </div>
          <div class="text-danger copy" v-text="$t('product.outOfStock')" />
        </div>
        <h3 v-if="options.length > 1" class="text-center text-primary mt-2 mb-0">
          <template
            v-if="
              option.smallInStock ||
              option.largeInStock ||
              option.XSInStock ||
              option.SInStock ||
              option.MInStock ||
              option.LInStock ||
              option.XLInStock
            "
          >
            <span style="cursor: pointer" @click="setColor(option.name)">{{ option.name }}</span>
          </template>
          <template v-else>
            <span class="text-muted">{{ option.name }}</span>
          </template>
        </h3>
      </b-col>
    </b-row>
    <ValidationProvider v-slot="{ errors }" vid="p-color-select" :rules="{ required: { allowFalse: false } }" slim>
      <input id="product-style-color" v-model="value" type="text" class="d-none" hidden />
      <span v-if="errors && errors[0]" class="text-danger">{{ $t('selectATag') }} {{ $t('Color') }}/{{ $t('style') }}</span>
    </ValidationProvider>
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';

export default {
  name: 'ColorSelect',
  mixins: [getImage, KeyboardNavigationMixins],
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      color: this.value,
    };
  },
  computed: {
    navigableOptions() {
      return this.options
        .filter(function (option) {
          return (
            option.smallInStock ||
            option.largeInStock ||
            option.XSInStock ||
            option.SInStock ||
            option.MInStock ||
            option.LInStock ||
            option.XLInStock
          );
        })
        .map((option) => option.name);
    },
  },
  created() {
    if (this.options?.length >= 1 && this.options?.[0] && (this.options?.[0]?.smallInStock || this.options?.[0]?.largeInStock)) {
      this.setColor(this.options[0].name);
    }
  },
  methods: {
    setColor(color) {
      if (color == this.color) {
        return;
      } else {
        this.color = color;
      }
      this.$emit('input', this.color);
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.color-option {
  border-radius: 10px;
  border: 2px solid $dp-gray-4;
  height: auto;
  background: transparent;
  img {
    width: 95%;
  }
  &.selected {
    border: 2px solid $dp-blue;
    background-color: rgba(204, 236, 249, 0.5);
  }
  &:hover,
  &:active,
  &:focus {
    &:not(.disabled) {
      border: 2px solid $dp-blue;
      box-shadow: 0 0 0 0.2rem $dp-light-blue;
      background-color: rgba(204, 236, 249, 0.5) !important;
    }
  }
}

.no-stock {
  border-radius: 10px;
  border: 2px solid white;
  height: auto;
  position: relative;
  img {
    width: 90%;
    filter: grayscale(80%);
  }
  svg {
    width: 80%;
    height: 80%;
    position: absolute;
    top: 10%;
    left: 10%;
    line {
      stroke: $dp-gray-5;
      stroke-width: 4;
    }
  }
}
</style>
